/**
 * Type check function to verify that maybeAFunction is a function
 */
export function isFunction(maybeAFunction: any): maybeAFunction is Function {
  return typeof maybeAFunction == "function";
}
